module.exports = __webpack_public_path__ + "img/pexels-berk-ozdemir-3779816.bb974769.jpg";